import { GET_WRITING_SURFACE_TYPES_SUCCESS } from "../actionTypes";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_WRITING_SURFACE_TYPES_SUCCESS: {
      const writingSurfaceTypes = action.payload;

      if (!writingSurfaceTypes){
        return [...state];
      }

      return [
        ...state,
        ...writingSurfaceTypes
      ]
    }
    default:
      return state;
  }
}
